import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { downloadFile } from "../data/misc";

import "./screenshotTool.css";

export default class ScreenshotTool extends React.Component {
  constructor(props) {
    super(props);

    this.state = { canScreenshot: true };

    this.takeScreenshot = this.takeScreenshot.bind(this);
  }

  componentDidMount() {
    if (this.props.playerContext) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.playerContext !== prevProps.playerContext &&
      this.props.playerContext
    ) {
      this.props.playerContext.onContextStateChanged(
        this.playerStateChanged.bind(this)
      );
    }
  }

  playerStateChanged(state) {
    this.setState({ canScreenshot: !state.playing });
  }

  takeScreenshot() {
    const video = this.props.videoRef.current;
    const playerContext = this.props.playerContext;
    if (!video || !playerContext) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0);

    downloadFile(
      canvas
        .toDataURL("image/jpeg")
        .replace("image/jpeg", "image/octet-stream"),
      `${playerContext.playingName}.jpg`
    );
  }

  render() {
    //use esri styles to look the same as the map buttons
    const buttonClass = "esri-widget--button";
    const buttonClassDisabled = "esri-widget--button esri-button--disabled";
    if (!this.props.playerContext || !this.props.playerContext.hasData)
      return null;

    return (
      <div className="screenshotTool">
        <div
          type="button"
          disabled={!this.state.canScreenshot}
          className={
            this.state.canScreenshot ? buttonClass : buttonClassDisabled
          }
          title="Capture Image"
          onClick={this.takeScreenshot}
        >
          <FontAwesomeIcon icon={faCamera} size="lg" />
        </div>
      </div>
    );
  }
}
